import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Section = styled.section`
  padding: 5rem 6%;
  background-color: #f7f7f7;
  text-align: center;
  
  @media (max-width: 768px) {
    padding: 4rem 6%;
  }
`;

const TrustedTitle = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 3rem;
  color: #000;
  position: relative;
  display: inline-block;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 2px;
    background-color: #000;
  }
`;

const LogoGrid = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    gap: 2rem;
  }
`;

const LogoContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;
  height: 25px;
  width: 100px;
  
  &:hover {
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.05);
  }
`;

const LogoImage = styled.img`
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
`;

const Trusted = () => {
  // Array of client logos from the public/clients folder
  const clientLogos = [
    'clients/1PAPER.ai.svg',
    'clients/3VYEPaT0UMn3qaoWelDDYkAft4.svg',
    'clients/Q3OpLN9GFoEJu3Flr9s7NXY98.svg',
    'clients/gEb9M6kVie9RDXtmGxil9askjIs.svg',
    'clients/DssbaZhlVEpnQhnhH39nAFIwLY.avif',
    'clients/PEHAilQRokHZTfDl0Lr1hBdxeU.avif',
    'clients/rs1TX9XrWn43tm1I1quoPGg4E.avif'
  ];

  return (
    <Section id="trusted">
      <TrustedTitle>Trusted by</TrustedTitle>
      <LogoGrid>
        {clientLogos.map((logo, index) => (
          <LogoContainer 
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <LogoImage src={logo} alt={`Client ${index + 1} logo`} />
          </LogoContainer>
        ))}
      </LogoGrid>
    </Section>
  );
};

export default Trusted; 